import React from 'react';
import { Link } from 'react-router-dom';
import styles from './ArticleCard.module.scss';

const ArticleCard = ({ article }) => {
    if (!article) return null;

    const formattedDate = article.publishedDate
        ? new Date(article.publishedDate).toLocaleDateString('en-GB', {
            day: 'numeric',
            month: 'long',
            year: 'numeric'
        })
        : '';

    return (
        <Link to={`/articles/${article.slug}`} className={styles.card}>
            {article.featuredImageUrl && (
                <div className={styles.imageWrapper}>
                    <img
                        src={article.featuredImageUrl}
                        alt={article.featuredImageAlt || article.title}
                        className={styles.image}
                    />
                    {article.categoryName && (
                        <span className={styles.categoryBadge}>{article.categoryName}</span>
                    )}
                </div>
            )}
            <div className={styles.content}>
                <h3 className={styles.title}>{article.title}</h3>
                {article.excerpt && (
                    <p className={styles.excerpt}>{article.excerpt}</p>
                )}
                <div className={styles.meta}>
                    <span className={styles.author}>{article.authorName || 'Game City'}</span>
                    {formattedDate && <span className={styles.date}>{formattedDate}</span>}
                </div>
            </div>
        </Link>
    );
};

export default ArticleCard;
